module.exports = __webpack_public_path__ + "fonts/Inter-900-latin84.8e433c0.woff2";